import { Grid } from '@material-ui/core';
import React from 'react';
import { ThemeProvider } from '../../../../theme-config/ThemeProvider';
import styles from './style';
import TroubleshootingTile from './TroubleshootingTile';

/**
 * @name TroubleshootingTileContainer
 * @param {*} props - Strapi Data
 * @returns {JSX.Element} - Renders TroubleshootingTile component
 */
const TroubleshootingTileContainer = props => {
    const classes = styles();
    return (
        <ThemeProvider palette={props?.cmsData?.Tile_theme?.theme}>
            <Grid container className={classes.troubleMainContainer}>
                <TroubleshootingTile cmsData={props?.cmsData} handleAction={props?.handleAction} />
            </Grid>
        </ThemeProvider>
    );
};
TroubleshootingTileContainer.displayName = 'TroubleshootingTileContainer';
export default TroubleshootingTileContainer;
